import React from 'react';
import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';

class LogoReveal extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef(); // 1. create a reference for the lottie player
  }
  componentDidMount() {
    // 3. listen for player load. see lottie player repo for other events
    this.myRef.current.addEventListener('load', function (e) {
      // 4. configure the interactivity library
      create({
        mode: 'scroll',
        player: '#firstLottie',
        actions: [
          {
            visibility: [0.3, 0.7],
            type: 'seek',
            loop: 'false',
            frames: [0, 75],
          },
        ],
      });
    });
  }
  render() {
    return (
      <div className="firstLottie">
        <div style={{ height: '10px' }}></div>
        <lottie-player
          ref={this.myRef} // 2. set the reference for the player
          id="firstLottie"
          renderer='canvas'
          mode="normal"
          src="https://assets10.lottiefiles.com/packages/lf20_zrpilomr.json"
          style={{ width: '1000px' }}
        ></lottie-player>
      </div>
    );
  }
}

export default LogoReveal;